export default __webpack_public_path__ + "0079df1d1aca6f63b4e9452cb93cd7f9.png";